import { IAttachment } from "../models/chat/chatItems";
import { HttpStatusCode } from "./httpStatusCodes";

export enum UploadFailReason {
  TooBig = "too_big",
  VirusFound = "virus_found",
  ScanFailed = "scan_failed",
  UnsupportedType = "unsupported_type",
  MalformedFileContent = "malformed_file_content"
}

export class UploadFailedVirusFound extends Error { }
export class UploadFailedTooBig extends Error { }
export class UploadFailedScanFailed extends Error { }
export class UploadFailedUnsupportedType extends Error { }
export class UploadFailedMalformedFileContent extends Error { }

export const selectContentType = (browserDetected: string, serverDetected: string): string => {
  return browserDetected && browserDetected.toLowerCase() !== "application/octet-stream"
    ? browserDetected
    : serverDetected;
};

export const mapUploadResponse = async (
  response: Response,
  fileType: string,
  fileToken: string,
  fileId?: string
): Promise<IAttachment> => {
  if (response.ok) {
    const responseBody = await response.json();
    return {
      id: fileId,
      token: fileToken,
      contentType: selectContentType(fileType, responseBody.contentType),
      fileName: responseBody.name,
      previews: responseBody.previews,
      size: responseBody.size
    } as IAttachment;
  } else if (response.status === HttpStatusCode.PAYLOAD_TOO_LARGE) {
    throw new UploadFailedTooBig();
  } else {
    const responseBody = await response.json();
    const error = responseBody.error;
    switch (error) {
      case UploadFailReason.VirusFound:
        throw new UploadFailedVirusFound();
      case UploadFailReason.TooBig:
        throw new UploadFailedTooBig();
      case UploadFailReason.ScanFailed:
        throw new UploadFailedScanFailed();
      case UploadFailReason.UnsupportedType:
        throw new UploadFailedUnsupportedType();
      case UploadFailReason.MalformedFileContent:
        throw new UploadFailedMalformedFileContent();
      default:
        throw new Error(response.statusText);
    }
  }
};
